// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";

// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   "https://api.shubhbhoomirealestate.com/adminapi";
// const IMAGE_API_URL =
//   process.env.REACT_APP_Image_URL || "https://api.shubhbhoomirealestate.com/";

// function Aminities() {
//   const [aminities, setAminities] = useState([]);
//   const [formData, setFormData] = useState({
//     id: null,
//     name: "",
//     image: null,
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const fetchAminities = async (page = currentPage, limit = itemsPerPage) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         alert(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         return;
//       }

//       const response = await fetch(
//         `${API_URL}/aminities-list?page=${page}&limit=${limit}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch amenities");
//       }
//       const data = await response.json();

//       if (data && data.data) {
//         setAminities(data.data);
//         setTotalItems(data.total || data.count || data.data.length);
//         setTotalPages(
//           data.totalPages ||
//             Math.ceil((data.total || data.data.length) / limit),
//         );
//         setCurrentPage(data.currentPage || page);
//       } else {
//         setAminities([]);
//         setTotalItems(0);
//         setTotalPages(0);
//       }
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);

//     const token = getAuthToken();
//     const formPayload = new FormData();
//     formPayload.append("name", formData.name);

//     if (formData.image) {
//       formPayload.append("image", formData.image);
//     }

//     let url;
//     if (formData.id) {
//       url = `${API_URL}/aminities-update`;
//       formPayload.append("id", formData.id);
//     } else {
//       url = `${API_URL}/aminities-create`;
//     }

//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         body: formPayload,
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to save amenity");
//       }

//       const result = await response.json();

//       if (result.success == "1") {
//         Swal.fire({
//           title: "Success!",
//           text: formData.id
//             ? "Amenity updated successfully!"
//             : "Amenity created successfully!",
//           icon: "success",
//           confirmButtonText: "OK",
//         });
//         setFormData({ id: null, name: "", image: null });
//         fetchAminities(1);
//       }
//     } catch (err) {
//       Swal.fire({
//         title: "Error!",
//         text: err.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     const token = getAuthToken();

//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (!result.isConfirmed) {
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       const response = await fetch(`${API_URL}/aminities-delete`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ id: id }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to delete amenity");
//       }

//       const result = await response.json();
//       if (result.status == "1") {
//         Swal.fire({
//           title: "Deleted!",
//           text: "Amenity has been deleted.",
//           icon: "success",
//           confirmButtonText: "OK",
//         });

//         if (aminities.length === 1 && currentPage > 1) {
//           fetchAminities(currentPage - 1);
//         } else {
//           fetchAminities(currentPage);
//         }
//       }
//     } catch (err) {
//       Swal.fire({
//         title: "Error!",
//         text: err.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (amenity) => {
//     setFormData({
//       id: amenity.id,
//       name: amenity.name,
//       image: null,
//     });
//   };

//   // Change page
//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     fetchAminities(pageNumber, itemsPerPage);
//   };

//   // Handle items per page change
//   const handleItemsPerPageChange = (e) => {
//     const newLimit = parseInt(e.target.value);
//     setItemsPerPage(newLimit);
//     setCurrentPage(1);
//     fetchAminities(1, newLimit);
//   };

//   useEffect(() => {
//     fetchAminities();
//   }, []);

//    return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
//         {/* 🎯 HEADER CARD */}
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "16px",
//             boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//             border: "1.5px solid #e2e8f0",
//             padding: "20px 24px",
//             display: "flex",
//             alignItems: "center",
//             gap: "16px",
//             marginBottom: "20px",
//           }}
//         >
//           <div
//             style={{
//               width: "52px",
//               height: "52px",
//               borderRadius: "14px",
//               background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#ffffff",
//               fontSize: "24px",
//               boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//               flexShrink: 0,
//             }}
//           >
//             🏢
//           </div>
//           <div>
//             <h1
//               style={{
//                 margin: 0,
//                 fontSize: "24px",
//                 fontWeight: "800",
//                 color: "#1e3a5f",
//                 letterSpacing: "-0.5px",
//               }}
//             >
//               {formData.id ? "Edit Amenity" : "Create New Amenity"}
//             </h1>
//             <p
//               style={{
//                 margin: "2px 0 0",
//                 fontSize: "13px",
//                 color: "#64748b",
//                 fontWeight: "500",
//               }}
//             >
//               Manage all amenities for your real estate projects
//             </p>
//           </div>
//         </div>

//         {/* 🎯 CREATE / EDIT FORM CARD */}
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "16px",
//             boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//             border: "1.5px solid #e2e8f0",
//             overflow: "hidden",
//             marginBottom: "20px",
//           }}
//         >
//           <div
//             style={{
//               height: "5px",
//               background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//             }}
//           />
//           <form onSubmit={handleSubmit} style={{ padding: "24px 28px" }}>
//             {error && (
//               <div
//                 style={{
//                   background: "#feeaeb",
//                   border: "1.5px solid #fecaca",
//                   borderRadius: "10px",
//                   padding: "12px 16px",
//                   marginBottom: "16px",
//                   fontSize: "13px",
//                   fontWeight: "600",
//                   color: "#dc2626",
//                 }}
//               >
//                 ⚠️ {error}
//               </div>
//             )}

//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
//                 gap: "16px",
//                 marginBottom: "20px",
//               }}
//             >
//               <div>
//                 <label
//                   htmlFor="amenityName"
//                   style={{
//                     display: "block",
//                     fontSize: "12.5px",
//                     fontWeight: "700",
//                     color: "#1e3a5f",
//                     marginBottom: "6px",
//                   }}
//                 >
//                   Amenity Name <span style={{ color: "#dc2626" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="amenityName"
//                   value={formData.name}
//                   placeholder="Enter amenity name"
//                   onChange={(e) =>
//                     setFormData({ ...formData, name: e.target.value })
//                   }
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "11px 14px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#f8fafc",
//                     fontSize: "13.5px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     boxSizing: "border-box",
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.borderColor = "#1e5799";
//                     e.target.style.background = "#ffffff";
//                     e.target.style.boxShadow = "0 0 0 4px rgba(30,87,153,0.1)";
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.borderColor = "#e2e8f0";
//                     e.target.style.background = "#f8fafc";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 />
//               </div>

//               <div>
//                 <label
//                   htmlFor="amenityImage"
//                   style={{
//                     display: "block",
//                     fontSize: "12.5px",
//                     fontWeight: "700",
//                     color: "#1e3a5f",
//                     marginBottom: "6px",
//                   }}
//                 >
//                   Amenity Image <span style={{ color: "#dc2626" }}>*</span>
//                 </label>
//                 <input
//                   type="file"
//                   id="amenityImage"
//                   onChange={(e) =>
//                     setFormData({ ...formData, image: e.target.files[0] })
//                   }
//                   required={!formData.id}
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#f8fafc",
//                     fontSize: "13px",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     boxSizing: "border-box",
//                   }}
//                 />
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: "10px",
//                 paddingTop: "20px",
//                 borderTop: "1.5px dashed #e2e8f0",
//               }}
//             >
//               {formData.id && (
//                 <button
//                   type="button"
//                   onClick={() =>
//                     setFormData({ id: null, name: "", image: null })
//                   }
//                   disabled={loading}
//                   style={{
//                     padding: "12px 24px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     color: "#64748b",
//                     fontSize: "13.5px",
//                     fontWeight: "700",
//                     cursor: loading ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   Cancel
//                 </button>
//               )}
//               <button
//                 type="submit"
//                 disabled={loading}
//                 style={{
//                   padding: "12px 32px",
//                   borderRadius: "10px",
//                   border: "none",
//                   background: loading
//                     ? "#cbd5e1"
//                     : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "13.5px",
//                   fontWeight: "700",
//                   cursor: loading ? "not-allowed" : "pointer",
//                   boxShadow: loading
//                     ? "none"
//                     : "0 6px 18px rgba(30, 87, 153, 0.3)",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                 }}
//               >
//                 {loading
//                   ? "Saving..."
//                   : formData.id
//                   ? "Update Amenity"
//                   : "Submit Amenity"}
//               </button>
//             </div>
//           </form>
//         </div>

//         {/* 🎯 LIST CARD */}
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "16px",
//             boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//             border: "1.5px solid #e2e8f0",
//             overflow: "hidden",
//           }}
//         >
//           <div
//             style={{
//               padding: "18px 28px",
//               background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//               borderBottom: "1.5px solid #e2e8f0",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <h3
//               style={{
//                 margin: 0,
//                 fontSize: "16px",
//                 fontWeight: "800",
//                 color: "#1e3a5f",
//               }}
//             >
//               📋 List of Amenities
//             </h3>
//             <span
//               style={{
//                 fontSize: "12px",
//                 fontWeight: "700",
//                 color: "#1e5799",
//                 background: "#e8f1fb",
//                 padding: "4px 12px",
//                 borderRadius: "20px",
//               }}
//             >
//               {totalItems} Total
//             </span>
//           </div>

//           <div style={{ padding: "20px 28px" }}>
//             {loading && (
//               <div style={{ textAlign: "center", padding: "40px" }}>
//                 <div
//                   style={{
//                     width: "40px",
//                     height: "40px",
//                     border: "3px solid #e2e8f0",
//                     borderTop: "3px solid #1e5799",
//                     borderRadius: "50%",
//                     margin: "0 auto 12px",
//                     animation: "spin 0.8s linear infinite",
//                   }}
//                 />
//                 <p style={{ color: "#64748b", fontSize: "13px", margin: 0 }}>
//                   Loading amenities...
//                 </p>
//               </div>
//             )}

//             {!loading && aminities.length === 0 && (
//               <div style={{ textAlign: "center", padding: "50px 20px" }}>
//                 <div style={{ fontSize: "40px", marginBottom: "12px" }}>📭</div>
//                 <h4
//                   style={{
//                     color: "#1e3a5f",
//                     fontWeight: "800",
//                     marginBottom: "6px",
//                   }}
//                 >
//                   No Amenities Found
//                 </h4>
//                 <p style={{ color: "#64748b", fontSize: "13px", margin: 0 }}>
//                   Create your first amenity using the form above.
//                 </p>
//               </div>
//             )}

//             {!loading && aminities.length > 0 && (
//               <>
//                 <div
//                   style={{
//                     overflowX: "auto",
//                     borderRadius: "12px",
//                     border: "1.5px solid #e2e8f0",
//                   }}
//                 >
//                   <table
//                     style={{
//                       width: "100%",
//                       borderCollapse: "collapse",
//                       fontSize: "13px",
//                     }}
//                   >
//                     <thead>
//                       <tr
//                         style={{
//                           background:
//                             "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                         }}
//                       >
//                         {["S.N", "Image", "Name", "Actions"].map((th, i) => (
//                           <th
//                             key={i}
//                             style={{
//                               padding: "14px 12px",
//                               color: "#ffffff",
//                               fontWeight: "700",
//                               fontSize: "11.5px",
//                               textAlign: "left",
//                               letterSpacing: "0.5px",
//                               textTransform: "uppercase",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {th}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {aminities.map((amenity, index) => (
//                         <tr
//                           key={amenity.id}
//                           style={{
//                             borderBottom: "1px solid #f1f5f9",
//                             transition: "background 0.2s ease",
//                           }}
//                           onMouseEnter={(e) =>
//                             (e.currentTarget.style.background = "#f8fafc")
//                           }
//                           onMouseLeave={(e) =>
//                             (e.currentTarget.style.background = "transparent")
//                           }
//                         >
//                           <td
//                             style={{
//                               padding: "12px",
//                               fontWeight: "700",
//                               color: "#1e5799",
//                             }}
//                           >
//                             {(currentPage - 1) * itemsPerPage + index + 1}
//                           </td>
//                           <td style={{ padding: "12px" }}>
//                             {amenity.image && (
//                               <img
//                                 src={`${IMAGE_API_URL}/aminities/${amenity.image}`}
//                                 alt={amenity.name}
//                                 style={{
//                                   width: "46px",
//                                   height: "46px",
//                                   objectFit: "cover",
//                                   borderRadius: "10px",
//                                   border: "1.5px solid #e2e8f0",
//                                 }}
//                               />
//                             )}
//                           </td>
//                           <td
//                             style={{
//                               padding: "12px",
//                               fontWeight: "600",
//                               color: "#1e3a5f",
//                             }}
//                           >
//                             {amenity.name}
//                           </td>
//                           <td style={{ padding: "12px" }}>
//                             <div
//                               style={{
//                                 display: "flex",
//                                 gap: "8px",
//                                 flexWrap: "wrap",
//                               }}
//                             >
//                               <button
//                                 onClick={() => handleEdit(amenity)}
//                                 disabled={loading}
//                                 style={{
//                                   padding: "7px 14px",
//                                   borderRadius: "8px",
//                                   border: "none",
//                                   background: "#fef3e2",
//                                   color: "#d97706",
//                                   fontSize: "12px",
//                                   fontWeight: "700",
//                                   cursor: loading
//                                     ? "not-allowed"
//                                     : "pointer",
//                                 }}
//                               >
//                                 ✏️ Edit
//                               </button>
//                               <button
//                                 onClick={() => handleDelete(amenity.id)}
//                                 disabled={loading}
//                                 style={{
//                                   padding: "7px 14px",
//                                   borderRadius: "8px",
//                                   border: "none",
//                                   background: "#feeaeb",
//                                   color: "#dc2626",
//                                   fontSize: "12px",
//                                   fontWeight: "700",
//                                   cursor: loading
//                                     ? "not-allowed"
//                                     : "pointer",
//                                 }}
//                               >
//                                 🗑️ Delete
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* Pagination */}
//                 {totalPages > 1 && (
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "flex-end",
//                       marginTop: "20px",
//                       gap: "6px",
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <button
//                       onClick={() => paginate(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       style={{
//                         minWidth: "38px",
//                         height: "38px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         background: "#ffffff",
//                         color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
//                         fontWeight: "700",
//                         cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                       }}
//                     >
//                       «
//                     </button>

//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 1 &&
//                           pageNumber <= currentPage + 1)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             style={{
//                               minWidth: "38px",
//                               height: "38px",
//                               borderRadius: "10px",
//                               border:
//                                 pageNumber === currentPage
//                                   ? "none"
//                                   : "1.5px solid #e2e8f0",
//                               background:
//                                 pageNumber === currentPage
//                                   ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                                   : "#ffffff",
//                               color:
//                                 pageNumber === currentPage
//                                   ? "#ffffff"
//                                   : "#334155",
//                               fontWeight: "700",
//                               fontSize: "13px",
//                               cursor: "pointer",
//                               boxShadow:
//                                 pageNumber === currentPage
//                                   ? "0 6px 16px rgba(30, 87, 153, 0.3)"
//                                   : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       }
//                       if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
//                         return (
//                           <span
//                             key={pageNumber}
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               padding: "0 6px",
//                               color: "#94a3b8",
//                               fontWeight: "700",
//                             }}
//                           >
//                             ...
//                           </span>
//                         );
//                       }
//                       return null;
//                     })}

//                     <button
//                       onClick={() => paginate(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       style={{
//                         minWidth: "38px",
//                         height: "38px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         background: "#ffffff",
//                         color:
//                           currentPage === totalPages ? "#cbd5e1" : "#1e5799",
//                         fontWeight: "700",
//                         cursor:
//                           currentPage === totalPages
//                             ? "not-allowed"
//                             : "pointer",
//                       }}
//                     >
//                       »
//                     </button>
//                   </div>
//                 )}

//                 <p
//                   style={{
//                     textAlign: "right",
//                     fontSize: "12px",
//                     color: "#94a3b8",
//                     marginTop: "10px",
//                     marginBottom: 0,
//                     fontWeight: "500",
//                   }}
//                 >
//                   Page {currentPage} of {totalPages} • {totalItems} total items
//                 </p>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Aminities;

import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://api.shubhbhoomirealestate.com/adminapi";
const IMAGE_API_URL =
  process.env.REACT_APP_Image_URL || "https://api.shubhbhoomirealestate.com/";

function Aminities() {
  const [aminities, setAminities] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    image: null,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const nameInputRef = useRef(null);

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH
  // ═══════════════════════════════════════════
  const fetchAminities = async (page = currentPage, limit = itemsPerPage) => {
    setLoading(true);
    setError(null);
    try {
      const token = getAuthToken();
      if (!token) {
        Swal.fire("Authentication Error", "Please log in.", "error");
        return;
      }

      const response = await fetch(
        `${API_URL}/aminities-list?page=${page}&limit=${limit}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch amenities");
      const data = await response.json();

      if (data && data.data) {
        setAminities(data.data);
        setTotalItems(data.total || data.count || data.data.length);
        setTotalPages(
          data.totalPages || Math.ceil((data.total || data.data.length) / limit)
        );
        setCurrentPage(data.currentPage || page);
      } else {
        setAminities([]);
        setTotalItems(0);
        setTotalPages(0);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 SUBMIT (Create / Update)
  // ═══════════════════════════════════════════
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const token = getAuthToken();
    const formPayload = new FormData();
    formPayload.append("name", formData.name);

    if (formData.image) {
      formPayload.append("image", formData.image);
    }

    let url;
    if (formData.id) {
      url = `${API_URL}/aminities-update`;
      formPayload.append("id", formData.id);
    } else {
      url = `${API_URL}/aminities-create`;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formPayload,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to save amenity");
      }

      const result = await response.json();

      if (result.success == "1") {
        Swal.fire({
          title: "Success!",
          text: formData.id
            ? "Amenity updated successfully!"
            : "Amenity created successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
        setFormData({ id: null, name: "", image: null });
        fetchAminities(1);
      }
    } catch (err) {
      Swal.fire("Error!", err.message, "error");
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE
  // ═══════════════════════════════════════════
  const handleDelete = async (id) => {
    const token = getAuthToken();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/aminities-delete`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to delete amenity");
      }

      const result = await response.json();
      if (result.status == "1") {
        Swal.fire("Deleted!", "Amenity has been deleted.", "success");

        if (aminities.length === 1 && currentPage > 1) {
          fetchAminities(currentPage - 1);
        } else {
          fetchAminities(currentPage);
        }
      }
    } catch (err) {
      Swal.fire("Error!", err.message, "error");
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT — FIXED with scroll + focus + toast
  // ═══════════════════════════════════════════
  // const handleEdit = (amenity) => {
  //   setFormData({
  //     id: amenity.id,
  //     name: amenity.name,
  //     image: null,
  //   });

  //   // Smooth scroll to top
  //   window.scrollTo({ top: 0, behavior: "smooth" });

  //   // Auto focus name input after scroll
  //   setTimeout(() => {
  //     nameInputRef.current?.focus();
  //   }, 600);

  //   // Info toast
  //   Swal.fire({
  //     title: "Edit Mode",
  //     text: `Editing "${amenity.name}". Update the form above and click Update.`,
  //     icon: "info",
  //     timer: 2000,
  //     showConfirmButton: false,
  //   });
  // };

  const handleEdit = (amenity) => {
  setFormData({
    id: amenity.id,
    name: amenity.name,
    image: null,
  });

  // Smooth scroll to top
  window.scrollTo({ top: 0, behavior: "smooth" });

  // Auto focus name input
  setTimeout(() => {
    nameInputRef.current?.focus();
  }, 600);
};

  // ═══════════════════════════════════════════
  // 🔹 CANCEL — FIXED with scroll
  // ═══════════════════════════════════════════
  const handleCancelEdit = () => {
    setFormData({ id: null, name: "", image: null });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION
  // ═══════════════════════════════════════════
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchAminities(pageNumber, itemsPerPage);
  };

  const handleItemsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setItemsPerPage(newLimit);
    setCurrentPage(1);
    fetchAminities(1, newLimit);
  };

  useEffect(() => {
    fetchAminities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ═══════════════════════════════════════════
  // 🎨 UI
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
        {/* 🎯 HEADER */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
            border: "1.5px solid #e2e8f0",
            padding: "20px 24px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              width: "52px",
              height: "52px",
              borderRadius: "14px",
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "24px",
              boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
              flexShrink: 0,
            }}
          >
            🏢
          </div>
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: "800",
                color: "#1e3a5f",
                letterSpacing: "-0.5px",
              }}
            >
              {formData.id ? "Edit Amenity" : "Create New Amenity"}
            </h1>
            <p
              style={{
                margin: "2px 0 0",
                fontSize: "13px",
                color: "#64748b",
                fontWeight: "500",
              }}
            >
              Manage all amenities for your real estate projects
            </p>
          </div>
        </div>

        {/* 🎯 FORM CARD */}
        <div
          id="amenity-form-card"
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: formData.id
              ? "0 0 0 3px rgba(30, 87, 153, 0.15), 0 8px 24px rgba(30, 87, 153, 0.08)"
              : "0 8px 24px rgba(30, 87, 153, 0.08)",
            border: formData.id ? "1.5px solid #1e5799" : "1.5px solid #e2e8f0",
            overflow: "hidden",
            marginBottom: "20px",
            transition: "all 0.3s ease",
          }}
        >
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          <form onSubmit={handleSubmit} style={{ padding: "24px 28px" }}>
            {error && (
              <div
                style={{
                  background: "#feeaeb",
                  border: "1.5px solid #fecaca",
                  borderRadius: "10px",
                  padding: "12px 16px",
                  marginBottom: "16px",
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#dc2626",
                }}
              >
                ⚠️ {error}
              </div>
            )}

            {/* Edit mode banner */}
            {formData.id && (
              <div
                style={{
                  background: "#e8f1fb",
                  border: "1.5px solid #bfdbfe",
                  borderRadius: "10px",
                  padding: "10px 16px",
                  marginBottom: "16px",
                  fontSize: "12.5px",
                  fontWeight: "600",
                  color: "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                ✏️ You are editing an existing amenity. Click "Update" to save
                changes.
              </div>
            )}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: "16px",
                marginBottom: "20px",
              }}
            >
              <div>
                <label
                  htmlFor="amenityName"
                  style={{
                    display: "block",
                    fontSize: "12.5px",
                    fontWeight: "700",
                    color: "#1e3a5f",
                    marginBottom: "6px",
                  }}
                >
                  Amenity Name <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  ref={nameInputRef}
                  type="text"
                  id="amenityName"
                  value={formData.name}
                  placeholder="Enter amenity name"
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                  style={{
                    width: "100%",
                    padding: "11px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#f8fafc",
                    fontSize: "13.5px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    outline: "none",
                    boxSizing: "border-box",
                    transition: "all 0.2s ease",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#1e5799";
                    e.target.style.background = "#ffffff";
                    e.target.style.boxShadow = "0 0 0 4px rgba(30,87,153,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e2e8f0";
                    e.target.style.background = "#f8fafc";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </div>

              <div>
                <label
                  htmlFor="amenityImage"
                  style={{
                    display: "block",
                    fontSize: "12.5px",
                    fontWeight: "700",
                    color: "#1e3a5f",
                    marginBottom: "6px",
                  }}
                >
                  Amenity Image{" "}
                  {!formData.id && <span style={{ color: "#dc2626" }}>*</span>}
                </label>
                <input
                  type="file"
                  id="amenityImage"
                  onChange={(e) =>
                    setFormData({ ...formData, image: e.target.files[0] })
                  }
                  required={!formData.id}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#f8fafc",
                    fontSize: "13px",
                    color: "#1e3a5f",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
                {formData.id && (
                  <p
                    style={{
                      fontSize: "11.5px",
                      color: "#64748b",
                      marginTop: "6px",
                      fontWeight: "500",
                    }}
                  >
                    Leave empty to keep existing image
                  </p>
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                paddingTop: "20px",
                borderTop: "1.5px dashed #e2e8f0",
              }}
            >
              {formData.id && (
                <button
                  type="button"
                  onClick={handleCancelEdit}
                  disabled={loading}
                  style={{
                    padding: "12px 24px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: "#64748b",
                    fontSize: "13.5px",
                    fontWeight: "700",
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                >
                  Cancel
                </button>
              )}
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: "12px 32px",
                  borderRadius: "10px",
                  border: "none",
                  background: loading
                    ? "#cbd5e1"
                    : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13.5px",
                  fontWeight: "700",
                  cursor: loading ? "not-allowed" : "pointer",
                  boxShadow: loading
                    ? "none"
                    : "0 6px 18px rgba(30, 87, 153, 0.3)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {loading
                  ? "Saving..."
                  : formData.id
                  ? "Update Amenity"
                  : "Submit Amenity"}
              </button>
            </div>
          </form>
        </div>

        {/* 🎯 LIST CARD */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              padding: "18px 28px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: "800",
                color: "#1e3a5f",
              }}
            >
              📋 List of Amenities
            </h3>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#1e5799",
                background: "#e8f1fb",
                padding: "4px 12px",
                borderRadius: "20px",
              }}
            >
              {totalItems} Total
            </span>
          </div>

          <div style={{ padding: "20px 28px" }}>
            {loading && (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    border: "3px solid #e2e8f0",
                    borderTop: "3px solid #1e5799",
                    borderRadius: "50%",
                    margin: "0 auto 12px",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
                <p style={{ color: "#64748b", fontSize: "13px", margin: 0 }}>
                  Loading amenities...
                </p>
              </div>
            )}

            {!loading && aminities.length === 0 && (
              <div style={{ textAlign: "center", padding: "50px 20px" }}>
                <div style={{ fontSize: "40px", marginBottom: "12px" }}>📭</div>
                <h4
                  style={{
                    color: "#1e3a5f",
                    fontWeight: "800",
                    marginBottom: "6px",
                  }}
                >
                  No Amenities Found
                </h4>
                <p style={{ color: "#64748b", fontSize: "13px", margin: 0 }}>
                  Create your first amenity using the form above.
                </p>
              </div>
            )}

            {!loading && aminities.length > 0 && (
              <>
                <div
                  style={{
                    overflowX: "auto",
                    borderRadius: "12px",
                    border: "1.5px solid #e2e8f0",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        }}
                      >
                        {["S.N", "Image", "Name", "Actions"].map((th, i) => (
                          <th
                            key={i}
                            style={{
                              padding: "14px 12px",
                              color: "#ffffff",
                              fontWeight: "700",
                              fontSize: "11.5px",
                              textAlign: "left",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {th}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {aminities.map((amenity, index) => {
                        const isEditing = formData.id === amenity.id;
                        return (
                          <tr
                            key={amenity.id}
                            style={{
                              borderBottom: "1px solid #f1f5f9",
                              background: isEditing ? "#e8f1fb" : "transparent",
                              transition: "background 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              if (!isEditing)
                                e.currentTarget.style.background = "#f8fafc";
                            }}
                            onMouseLeave={(e) => {
                              if (!isEditing)
                                e.currentTarget.style.background =
                                  "transparent";
                            }}
                          >
                            <td
                              style={{
                                padding: "12px",
                                fontWeight: "700",
                                color: "#1e5799",
                              }}
                            >
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td style={{ padding: "12px" }}>
                              {amenity.image && (
                                <img
                                  src={`${IMAGE_API_URL}/aminities/${amenity.image}`}
                                  alt={amenity.name}
                                  style={{
                                    width: "46px",
                                    height: "46px",
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                    border: "1.5px solid #e2e8f0",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              )}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                fontWeight: "600",
                                color: "#1e3a5f",
                              }}
                            >
                              {amenity.name}
                            </td>
                            <td style={{ padding: "12px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <button
                                  onClick={() => handleEdit(amenity)}
                                  disabled={loading}
                                  style={{
                                    padding: "7px 14px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: isEditing
                                      ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                      : "#fef3e2",
                                    color: isEditing ? "#ffffff" : "#d97706",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                    cursor: loading
                                      ? "not-allowed"
                                      : "pointer",
                                    transition: "all 0.2s ease",
                                  }}
                                >
                                  {isEditing ? "✏️ Editing..." : "✏️ Edit"}
                                </button>
                                <button
                                  onClick={() => handleDelete(amenity.id)}
                                  disabled={loading}
                                  style={{
                                    padding: "7px 14px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "#feeaeb",
                                    color: "#dc2626",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                    cursor: loading
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                >
                                  🗑️ Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      onClick={() => paginate(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      }}
                    >
                      «
                    </button>

                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      if (
                        pageNumber === 1 ||
                        pageNumber === totalPages ||
                        (pageNumber >= currentPage - 1 &&
                          pageNumber <= currentPage + 1)
                      ) {
                        return (
                          <button
                            key={pageNumber}
                            onClick={() => paginate(pageNumber)}
                            style={{
                              minWidth: "38px",
                              height: "38px",
                              borderRadius: "10px",
                              border:
                                pageNumber === currentPage
                                  ? "none"
                                  : "1.5px solid #e2e8f0",
                              background:
                                pageNumber === currentPage
                                  ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                  : "#ffffff",
                              color:
                                pageNumber === currentPage
                                  ? "#ffffff"
                                  : "#334155",
                              fontWeight: "700",
                              fontSize: "13px",
                              cursor: "pointer",
                              boxShadow:
                                pageNumber === currentPage
                                  ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                                  : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      }
                      if (
                        pageNumber === currentPage - 2 ||
                        pageNumber === currentPage + 2
                      ) {
                        return (
                          <span
                            key={pageNumber}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "0 6px",
                              color: "#94a3b8",
                              fontWeight: "700",
                            }}
                          >
                            ...
                          </span>
                        );
                      }
                      return null;
                    })}

                    <button
                      onClick={() => paginate(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color:
                          currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      »
                    </button>
                  </div>
                )}

                <p
                  style={{
                    textAlign: "right",
                    fontSize: "12px",
                    color: "#94a3b8",
                    marginTop: "10px",
                    marginBottom: 0,
                    fontWeight: "500",
                  }}
                >
                  Page {currentPage} of {totalPages} • {totalItems} total items
                </p>
              </>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default Aminities;
